

/* -- opções de assinatura e pagamentos ------------------------------------------------------------------- 
step 0:
    status 3: todas as opções de pagamento para o cliente fazer a assinatura (boleto, pix ou cartão)
    status 4: histórico de pagamentos, informações de pagamento, alteração de cartão, pagamento na tela (pix ou boleto),
              alteração na forma de pagamento e cancelamento de assinatura/conta
step 1:
    status 3: tela de pagamento por pix ou boleto bancário (dependendo da escolha)

step 2: 
    status 3: conclusão de pagamento por qualquer forma (boleto, pix ou cartão) e de qualquer operação

step 4:
    status 3: tela de pagamento por cartão de crédito

**** fazer ****
step 3:
    status 4: tela para alteração do cartão de crédito

step 5:
    status 4: tela para alteração da forma de pagamento (instruções sobre as regras)

step 6:
    status 4: cancelamento de assinatura e encerramento de conta
-- --------------------------------------------------------------------------------------------------------- */



import "./billing.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* redux */
import { useSelector, useDispatch } from "react-redux";
import { updateAgent } from "../../redux/agent/slice";

/* formulário */
import { useForm } from "react-hook-form";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, where, query, limit, addDoc, onSnapshot, doc, updateDoc, Timestamp, orderBy } from "firebase/firestore";

/* funções auxiliares */
import { firstName, expiryDate, showError, clearError, formError, validarCPFouCNPJ, wait, registerLog, formatTimestamp } from "../../services/functions/functions.ts";

/* validação de campos */
import { maskdocumento, maskcartao, maskvencimento } from "../../services/masks/masks.ts";

/* imagens */
import icon_success from "../../assets/sucesso.png";
import icon_whats from "../../assets/whats_icon.png";
import image_pix from "../../assets/billing_pix.png";
import image_boleto from "../../assets/billing_boleto.png";
import image_cartao from "../../assets/billing_credit.png";


/* código de barras */
import JsBarcode from "jsbarcode";



export default function Billing() {

    const [step, setStep] = useState(0);
    const [prevStep, setPrevStep] = useState(0);
    const [error, setError] = useState("0");
    const [cep, setCep] = useState("");
    const [numero, setNumero] = useState("");
    const [idClienteAsaas, setIdClienteAsaas] = useState([]);
    const [idPaymentAsaas, setIdPaymentAsaas] = useState([]);
    const [idSubscriptionAsaas, setIdSubscriptionAsaas] = useState([]);
    const [idBillingAsaas, setIdBillingAsaas] = useState([]);

    const [historyPayment, setHistoryPayment] = useState({parcelas: [],});
    const [infoPlan, setInfoPLan] = useState([]);

    const dispatch = useDispatch();

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const [plans, setPlans] = useState([]);

    const { handleSubmit, register, getValues, setValue } = useForm();

    const [isPending, startTransition] = useTransition();
    const [isPaying, setIsPaying] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    const [billingData, setBillingData] = useState(null);
    const [billingDocId, setBillingDocId] = useState(null);

    const [payment, setPayment] = useState("pix");


    /* refs para tratamento de erros */
    const refDocumento = useRef(null);
    const refLabelDocumento = useRef(null);
    const refErrorDocumento = useRef(null);

    //cartão de crédito
    const refNumeroCartao = useRef(null);
    const refLabelNumeroCartao = useRef(null);
    const refErrorNumeroCartao = useRef(null);

    const refVencimentoCartao = useRef(null);
    const refLabelVencimentoCartao = useRef(null);

    const refNomeCartao = useRef(null);
    const refLabelNomeCartao = useRef(null);
    const refErrorNomeCartao = useRef(null);

    const refCodigoCartao = useRef(null);
    const refLabelCodigoCartao = useRef(null);

    const refCheckBox = useRef(null);

    const refErrorCartao = useRef(null);
    const refButtonCartao = useRef(null);
    const refErrorCancelar = useRef(null);
    const refErrorTerms = useRef(null);

    const refError = useRef(null);
    const refButton = useRef(null);
    const refLoad = useRef(null);
    /* -- */


    useEffect(() => { window.scrollTo(0, 0); }, []);

    const handleChange = (event) => { setPayment(event.target.value); };

    useEffect(() => {
        async function loadInfos() {
    
            startTransition(async () => {
      
                try {

                    const uid = user.id;
                    const aid = agent.id;
                    const cod = agent.plano;

                    //prepara as queries
                    const clientQuery = query(collection(db, "clients"), where("id", "==", uid), limit(1));

                    const planQuery = query(collection(db, "plans"), where("codigo", ">=", cod), where("codigo", "<=", cod + "\uf8ff"), where("data_termino_vigencia", "==", expiryDate()));

                    const cepQuery = query(collection(db, "medical"), where("id_agent", "==", aid), limit(1));

                    //executa todas ao mesmo tempo
                    const [clientSnap, planSnap, cepSnap] = await Promise.all([
                    getDocs(clientQuery),
                    getDocs(planQuery),
                    getDocs(cepQuery),
                    ]);

                    //client
                    if(!clientSnap.empty) {
                        const clientData = clientSnap.docs[0].data();
                        setValue("responsavel", clientData.responsavel || "");
                        setValue("email", clientData.email || "");
                        setValue("telefone", clientData.telefone || "");
                    }

                    //plans
                    if(!planSnap.empty) {
                        const plans = planSnap.docs.map((doc) => ({
                            id: doc.id,
                            codigo: doc.data().codigo,
                            ramo: doc.data().ramo,
                            atendimento: doc.data().atendimento,
                            valor: doc.data().valor,
                        }));
                        setPlans(plans);
                    } else {
                        setPlans([]);
                    }

                    //cep
                    if(!cepSnap.empty) {
                        const cepData = cepSnap.docs[0].data();
                        setCep(cepData.cep);
                        setNumero(cepData.numero);
                    }

                } catch (erro) {
                    console.error("Erro ao carregar infos:", erro);
                    refLoad.current.innerHTML = erro.message || String(erro);
                }
            });
        }

        async function loadPayments() {
        
           startTransition(async () => {
      
                try {

                    let aid = agent.id;
                    let pln = agent.plano;

                    const billingQuery = query(collection(db, "billings"), where("id_agent", "==", aid), orderBy("data_criacao", "desc"), limit(1));
                    const planQuery = query(collection(db, "plans"), where("codigo", "==", pln), limit(1));

                    const [billingSnap, planSnap] = await Promise.all([getDocs(billingQuery), getDocs(planQuery),]);

                    if(!billingSnap.empty) {
                        const hb = billingSnap.docs[0].data();
                        setHistoryPayment(hb);
                    }
                    
                    if(!planSnap.empty) {
                        const pl = planSnap.docs[0].data();
                        setInfoPLan(pl);
                    }

                } catch (erro) {
                    console.error("Erro ao carregar payments:", erro);

                }

            });
        }

        if(agent.status === 3) {
            loadInfos();
        } else {
            loadPayments();
        }

    }, []);



    async function create_payment(e) {

        e.preventDefault();
        formError(refError, "", false);

        let dc = getValues("documento");
        if(dc.length !== 14 && dc.length !== 18) {
            showError(refDocumento, refLabelDocumento, refErrorDocumento, "Insira um CPF ou CNPJ com todos os dígitos.", setError, "documento");
            return;
        }

        if(!validarCPFouCNPJ(dc)) {
            showError(refDocumento, refLabelDocumento, refErrorDocumento, "Esse número de CPF ou CNPJ é inválido.", setError, "documento");
            return;
        }

        setIsPaying(true);

        try {

            const uid = user.id;
            const aid = agent.id;
            const nom = user.empresa;
    
            let id_client_asaas = [];
            let id_payment_asaas = [];
            let id_subscription_assas = [];
            let id_billing_assas = [];

            refButton.current.innerHTML = "AGUARDE ... verificando cliente";

            //cria ou retorna cliente asaas
            const resClientAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/upsertclient", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    documento: getValues("documento"),
                    nome: getValues("responsavel"),
                    email: getValues("email"),
                    telefone: getValues("telefone"),
                    empresa: nom,
                    cep: cep.replace("-", ""),
                    numero: numero,
                    idagent: aid,
                    idclient: uid
                })
            });

            if(!resClientAsaas.ok) {
                setIsPaying(false);
                const errorData = await resClientAsaas.json();
                formError(refError, JSON.stringify(errorData), true);
                refButton.current.innerHTML = "FAZER ASSINATURA";
                return;            
            } else {
                const dataClientAsaas = await resClientAsaas.json();
                id_client_asaas = dataClientAsaas;
                setIdClienteAsaas(id_client_asaas);
            }

            wait(500);
            registerLog(uid, "/billing/step1/pagamento=" + payment);

            if(payment === "credito") {

                setIsPaying(false);
                refButton.current.innerHTML = "FAZER ASSINATURA";
                setStep(4);
                window.scrollTo(0, 0);

            } else {

                refButton.current.innerHTML = "AGUARDE ... criando assinatura";

                //cria assinatura para pix ou boleto e resgata a primeira fatura
                const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
                const dataFormatada = amanha.toISOString().split('T')[0];

                const resCreateSubscriptionAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/createsubscription", 
                { method: "POST", headers: {"Content-Type": "application/json"} ,
                    body: JSON.stringify(
                    {
                        cliente: id_client_asaas.cliente.id,
                        pagamento: payment.toUpperCase(),
                        valor: plans[0].valor,
                        vencimento: dataFormatada,
                        idagent: aid,
                        descricao: "WINNERS-AI Assinatura - Plano: " + plans[0].ramo + ", Código do Plano: " + plans[0].codigo + ", Valor: R$ " + plans[0].valor.toFixed(2)
                    })
                });
                
                if(!resCreateSubscriptionAsaas.ok) {
                    setIsPaying(false);
                    const errorData = await resCreateSubscriptionAsaas.json();
                    formError(refError, JSON.stringify(errorData), true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                } else {
                    const dataCreateSubscriptionAsaas = await resCreateSubscriptionAsaas.json();
                    id_subscription_assas = dataCreateSubscriptionAsaas.assinatura;
                    id_payment_asaas = dataCreateSubscriptionAsaas.primeira_fatura;
                    setIdSubscriptionAsaas(id_subscription_assas);
                    setIdPaymentAsaas(id_payment_asaas);
                }

                wait(500);
                console.log(id_payment_asaas);
                
                //resgata informações da cobrança
                const resPaymentInfoAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/paymentinfo", 
                { method: "POST", headers: {"Content-Type": "application/json"} ,
                    body: JSON.stringify(
                    {
                        idcobranca: id_payment_asaas.id
                    })
                });
                
                if(!resPaymentInfoAsaas.ok) {
                    setIsPaying(false);
                    const errorData = await resPaymentInfoAsaas.json();
                    formError(refError, JSON.stringify(errorData), true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                } else {
                    const dataPaymentInfoAsaas = await resPaymentInfoAsaas.json();
                    id_billing_assas = dataPaymentInfoAsaas.informacoes;
                    setIdBillingAsaas(id_billing_assas);
                }

                wait(500);
                console.log(id_billing_assas);

                refButton.current.innerHTML = "AGUARDE ... registrando dados";

                const rb = await registrar_billing(uid, aid, id_client_asaas.cliente.id, id_subscription_assas.id, id_payment_asaas.id, payment.toUpperCase());
                if(rb.erro) {
                    setIsPaying(false);
                    formError(refError, "Erro ao registar dados: " + rb.status, true);
                    refButton.current.innerHTML = "FAZER ASSINATURA";
                    return;            
                }
                
                refButton.current.innerHTML = "FAZER ASSINATURA";
                setIsPaying(false);

                registerLog(uid, "/billing/step2/id_agent=" + aid + ", customer_asaas=" + id_client_asaas.cliente.id + ", subscription_assas=" + id_subscription_assas.id + ", cobrança_asaas=" + id_payment_asaas.id);

                setBillingData(id_billing_assas);
                setBillingDocId(rb.status);
            
                setStep(1);
                window.scrollTo(0, 0);
                
            }
        
        }
        catch(erro) {

            setIsPaying(false);
            formError(refError, erro, true);
            refButton.current.innerHTML = "FAZER ASSINATURA";

        }

    }


    async function create_payment_card(e) {

        e.preventDefault();
        formError(refErrorCartao, "", false);

        let cn = getValues("card_number");
        if(cn.length < 19) {
            showError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, "Insira um número de cartão com todos os dígitos", setError, "card_number");
            return;
        }

        let cv = getValues("card_expiry");
        if(cv.length < 5) {
            showError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, "Insira uma data de validade do cartão correta", setError, "card_expiry");
            return;
        }

        let cm = getValues("card_name");
        if(cm.length < 3) {
            showError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, "Insira um nome impresso de cartão válido", setError, "card_name");
            return;
        }

        let cc = getValues("card_code");
        if(cc.length < 3) {
            showError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, "Insira um código de segurança com 3 dígitos", setError, "card_code");
            return;
        }

        setIsPaying(true);

        try {

            let uid = user.id;
            let aid = agent.id;
            
            let id_payment_asaas = [];
            let id_subscription_assas = [];

            refButtonCartao.current.innerHTML = "AGUARDE ... criando assinatura";

            const resip = await fetch("https://api.ipify.org?format=json");
            const dataip = await resip.json();
            const ip = dataip.ip;

            //cria assinatura para cartão de crédito e busca a primeira fatura
            const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
            const dataFormatada = amanha.toISOString().split('T')[0];

            const resCreateSubscriptionAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/createsubscription", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    cliente: idClienteAsaas.cliente.id,
                    pagamento: "CREDIT_CARD",
                    valor: plans[0].valor,
                    vencimento: dataFormatada,
                    idagent: aid,
                    descricao: "WINNERS-AI Assinatura - Plano: " + plans[0].ramo + ", Código do Plano: " + plans[0].codigo + ", Valor: R$ " + plans[0].valor.toFixed(2)
                })
            });
            
            if(!resCreateSubscriptionAsaas.ok) {
                setIsPaying(false);
                const errorData = await resCreateSubscriptionAsaas.json();
                formError(refErrorCartao, JSON.stringify(errorData), true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            } else {
                const dataCreateSubscriptionAsaas = await resCreateSubscriptionAsaas.json();
                id_subscription_assas = dataCreateSubscriptionAsaas.assinatura;
                id_payment_asaas = dataCreateSubscriptionAsaas.primeira_fatura;
                setIdSubscriptionAsaas(id_subscription_assas);
                setIdPaymentAsaas(id_payment_asaas);
            }

            wait(500);
            refButtonCartao.current.innerHTML = "AGUARDE ... processando pagamento";

            const resPaymentCardAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/paymentcard", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    idcobranca: id_payment_asaas.id,
                    cartao_nome: getValues("card_name"),
                    cartao_numero: getValues("card_number"),
                    cartao_mes: getValues("card_expiry").slice(0, 2),
                    cartao_ano: "20" + getValues("card_expiry").slice(-2),
                    cartao_codigo: getValues("card_code"),
                    info_nome: getValues("responsavel"),
                    info_email: getValues("email"),
                    info_documento: getValues("documento"),
                    info_cep: cep,
                    info_numero: numero,
                    info_telefone: getValues("telefone"),
                    ip_remoto: ip
                })
            });

            if(!resPaymentCardAsaas.ok) {
                setIsPaying(false);
                const errorData = await resPaymentCardAsaas.json();
                formError(refErrorCartao, JSON.stringify(errorData), true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            } else {
                const dataPaymentCardAsaas = await resPaymentCardAsaas.json();
                console.log(dataPaymentCardAsaas);
            }
            
            wait(500);
            refButtonCartao.current.innerHTML = "AGUARDE ... registrando dados";

            const rb = await registrar_billing(uid, aid, idClienteAsaas.cliente.id, id_subscription_assas.id, id_payment_asaas.id, "CARTÃO CRÉDITO");
            if(rb.erro) {
                setIsPaying(false);
                formError(refErrorCartao, "Erro ao registar dados: " + rb.status, true);
                refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";
                return;            
            }

            registerLog(uid, "/billing/step2/id_agent=" + aid + ", customer_asaas=" + idClienteAsaas.cliente.id + ", subscription_assas=" + id_subscription_assas.id + ", cobrança_asaas=" + id_payment_asaas.id);

            refButtonCartao.current.innerHTML = "AGUARDE ... recebendo pagamento";

            setBillingDocId(rb.status);

        }
        catch(erro) {

            setIsPaying(false);
            formError(refErrorCartao, erro, true);
            refButtonCartao.current.innerHTML = "FAZER PAGAMENTO";

        }

    }



    async function registrar_billing(uid, aid, cliente_asaas, assinatura_asaas, cobranca_assas, tipo_cobranca) {

        try {

            //registra os dados no firebase
            const hoje = new Date();
            const amanha = new Date(Date.now() + 24 * 60 * 60 * 1000);
            amanha.setHours(23, 59, 59, 0);
            
            const docbilling = await addDoc(collection(db, "billings"), {
                id_client: uid,
                id_agent: aid,
                id_client_asaas: cliente_asaas,
                id_subscription_asaas: assinatura_asaas,
                status: "ACTIVE",
                data_criacao: hoje,
                parcelas: [{id_payment_asaas: cobranca_assas, mensalidade: 1, vencimento: Timestamp.fromDate(amanha), valor: plans[0].valor, status: "PENDING", tipo: tipo_cobranca, data_pagamento: null}],
                dia_vencimento: amanha.getDate(),
                data_encerramento: null,
            });

            const clientquery = query(collection(db, "clients"), where("id", "==", uid));
            const clientdados = await getDocs(clientquery);

            const clientdoc = clientdados.docs[0];

            await updateDoc(clientdoc.ref, {
                documento: getValues("documento"),
            });

            return {erro: false, status: docbilling.id};

        }
        catch(erro) {
            return {erro: true, status: erro};
        }
        
    }



    function TelaPagamento({data}) {
  
        const svgRef = useRef(null);

        //gera o código de barras do boleto (se houver)
        useEffect(() => {
            if (data?.bankSlip?.barCode) {
                JsBarcode(svgRef.current, data.bankSlip.barCode, {format: "ITF", lineColor: "#000", width: 1.6, height: 70, displayValue: false,});
            }
        }, [data]);

        //se tiver boleto, prioriza ele
        const isBoleto = !!data?.bankSlip;
        const isPix = !!data?.pix && !isBoleto; // só mostra PIX se não houver boleto

        if(!isPix && !isBoleto) {
            return (
                <div className="flex flex-col items-center gap-6">
                    <span className="text-gray-500">Nenhuma informação de pagamento disponível.</span>
                </div>
            );
        }

        return (
            <div className="flex flex-col items-center gap-6">
            {/* PIX */}
            {isPix && (
            <>
            <span className="title_form">Pix QR Code</span>
            <div className="billing_box_pix"><img src={`data:image/png;base64,${data.pix.encodedImage}`} alt="QR Code PIX" className="billing_pix_qrcode" />
            <span className="space_form"></span>
            <span className="billing_pix_payload">{data.pix.payload}</span>
            <div className="billing_box_pix_button">
                <button onClick={() => navigator.clipboard.writeText(data.pix.payload)} className="buttonsearch_form">Copiar código PIX</button>
            </div>
            <span className="space_form"></span>
            </div>
            </>
            )}

            {/* boleto */}
            {isBoleto && (
            <>
            <span className="title_form">Boleto Bancário</span>
            <div className="billing_box_boleto">
                <svg className="billing_boleto_barras" ref={svgRef}></svg>
                <span className="space_form"></span>
                <span className="billing_boleto_digitavel">Linha Digitável</span>
                <span className="billing_boleto_linha">{data.bankSlip.identificationField.replace(/^(\d{5})(\d{5})(\d{5})(\d{6})(\d{5})(\d{6})(\d{1})(\d{14})$/, "$1.$2 $3.$4 $5.$6 $7 $8")}</span>
                <span className="space_form"></span>
                <div className="billing_box_boleto_button"><a href={data.bankSlip.bankSlipUrl} target="_blank" rel="noopener noreferrer" className="billing_boleto_link">Abrir boleto PDF</a></div>
            </div>
            <span className="space_form"></span>
            </>
            )}
        </div>
        );
    }


    useEffect(() => {
  
        if (!billingDocId) return;

        const docRef = doc(db, "billings", billingDocId);

        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if(docSnap.exists()) {
                const docData = docSnap.data();

                //procura alguma parcela com status = "PAID"
                const parcelas = docData.parcelas || [];
                const parcelaPaga = parcelas.find(p => p.status === "PAID" && p.mensalidade === 1);

                if(parcelaPaga) {
        
                    //atualiza status e muda tela
                    sessionStorage.setItem('status', JSON.stringify(4));

                    dispatch(updateAgent({
                    id: agent.id,
                    nome: agent.nome,
                    plano: agent.plano,
                    status: 4,
                    }));

                    setStep(2);
                    window.scrollTo(0, 0);
                }
            }
        });

        return () => unsubscribe();

    }, [billingDocId]);



    async function cancell_subscription(data) {

        formError(refErrorCancelar, "", false);
        setPrevStep(6);

        if(!refCheckBox.current.checked) {
            refErrorTerms.current.innerHTML = "Para encerrar a conta você deve aceitar os termos de uso.";
            refErrorTerms.current.style.height = "1.5rem";
            return;
        } else {
            refErrorTerms.current.innerHTML = "";
            refErrorTerms.current.style.height = "0rem";
        }

        try {

            setIsCancelling(true);

            let ids = historyPayment.id_subscription_asaas;
            let aid = agent.id;
            let uid = user.id;
            let dta = new Date();

            //exclui a assinatura
            const resCancellAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/cancellsubscription", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    assinatura: ids
                })
            });
                    
            if(!resCancellAsaas.ok) {

                const errorData = await resCancellAsaas.json();
                formError(refErrorCancelar, JSON.stringify(errorData), true);
                return;    

            } else {

                //atualiza billing
                const billingquery = query(collection(db, "billings"), where("id_subscription_asaas", "==", ids));
                const billingdados = await getDocs(billingquery);

                const billingref = doc(db, "billings", billingdados.docs[0].id);
                const billingupdate = await updateDoc(billingref, {status: "CANCEL", data_encerramento: dta});

                //atualiza agent
                const agentgref = doc(db, "agents", aid);
                const agentgupdate = await updateDoc(agentgref, {status: 5, data_termino_ativacao: dta, data_termino_vigencia: dta, status_motivo: "desativação a pedido do cliente"});

                sessionStorage.setItem('status', JSON.stringify(5));

                dispatch(updateAgent({
                    id: aid,
                    nome: agent.nome,
                    plano: agent.plano,
                    status: 5,
                }))
                
                //atualiza agents content
                const agentscontentquery = query(collection(db, "medical"), where("id_agent", "==", aid));
                const agentscontentdados = await getDocs(agentscontentquery);

                const agentscontentref = doc(db, "medical", agentscontentdados.docs[0].id);
                const agentscontentupdate = await updateDoc(agentscontentref, {data_termino_vigencia: dta});

                //atualiza uses 
                const usesquery = query(collection(db, "uses"), where("id_agent", "==", aid));
                const usesdados = await getDocs(usesquery);

                const usesref = doc(db, "uses", usesdados.docs[0].id);
                const usesupdate = await updateDoc(usesref, {data_termino_vigencia: dta});

                let tel = usesdados.docs[0].data().id_telephone;

                //atualiza telephones
                const telephonesref = doc(db, "telephones", tel);
                const telephonesupdate = await updateDoc(telephonesref, {status: 1});

                registerLog(uid, "/cancell_subscription");

                setStep(2);
                window.scrollTo(0, 0);

            }

        }
        catch(erro) {
            formError(refErrorCancelar, erro, true);
        }
        finally {
            setIsCancelling(false);
        }
        
    }



    return(
        <div className="context">
                            
            <Header access={1}></Header>
                    
            <div className="content">

                {/* tela inicial - opções de pagamento para não assinantes (agents status 3) e configurações de pagamentos (agentes status 4) */}
                { step === 0 && (
                     agent.status === 3 ? (
                    <>
                    <span className="ft_topico">Faça a sua assinatura</span>
                    <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                    <div className="space"></div>

                    <div className="border_form billing_border_form">
                        <form className="form">
                            { isPending ? (<><span ref={refLoad} className="load_form">aguarde carregando formulário ...</span></>) : (
                            <>
                            <span className="title_form">Assinatura</span>
                            <span className="subtitle_form">{firstName(user.nome)}, já temos alguns de seus dados.<br />Agora você só precisa informar o CPF ou CNPJ, seu plano e a forma de pagamento.</span>
                            <span className="space_form"></span>

                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" disabled={true} {...register("responsavel")}></input>
                            <span className="label">Responsável</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <div className="billing_box">

                                <div className="billing_box01a">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} {...register("email")}></input>
                                    <span className="label">Email</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                                <div className="billing_box01b"></div>

                                <div className="billing_box01c">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} {...register("telefone")}></input>
                                    <span className="label">Telefone</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                            </div>
                            <span className="space_form"></span>

                            <span ref={refErrorDocumento} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelDocumento}>
                            <input type="text" placeholder="&nbsp;" maxLength={18} {...register("documento")} ref={(el) => {refDocumento.current = el; register("documento").ref(el);}} onClick={() => clearError(refDocumento, refLabelDocumento, refErrorDocumento, error, setError)} onChange={(e) => {if (error === "0") {setValue("documento", maskdocumento(e.target.value));} else {clearError(refDocumento, refLabelDocumento, refErrorDocumento, error, setError);}}}></input>
                            <span className="label">CPF ou CNPJ</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                           <div className="billing_box_plans">
                                <span className="billing_box_plans_title">Planos Disponíveis:</span>
                                { plans.map((item, index) => (
                                <>
                                <div className="billing_box_plans_item" key={index}>
                                    <span className="billing_box_plans_itemA"><input type="radio" name="plans" value={item.codigo} className="radio_custom" checked={true}></input></span>
                                    <span className="billing_box_plans_itemB">{item.ramo}</span>
                                    <span className="billing_box_plans_itemC"><img className="billing_image_whats" src={icon_whats}></img></span>
                                    <span className="billing_box_plans_itemD">R$ {item.valor.toFixed(2)}</span>
                                </div>
                                </>
                                ))}
                            </div>
                            <span className="space_form"></span>

                            <div className="billing_box_plans">
                                <span className="billing_box_plans_title">Pagamentos Disponíveis:</span>
                                <div className="billing_box_plans_item">
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="pix" className="radio_custom" checked={payment === "pix"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Pix</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_pix}></img></div>
                                        </div>
                                    </div>
                                    <div className="billing_box_space"><span className="billing_box_space_line"></span></div>
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="boleto" className="radio_custom" checked={payment === "boleto"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Boleto</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_boleto}></img></div>
                                        </div>

                                    </div>
                                    <div className="billing_box_space"><span className="billing_box_space_line"></span></div>
                                    <div className="billing_box_payment">
                                        <div className="billing_box_payment_item">
                                            <div className="billing_box_payment_item_option">
                                                <input type="radio" name="payment" value="credito" className="radio_custom" checked={payment === "credito"} onChange={handleChange}></input>
                                                <span className="billing_box_payment_item_text">Cartão de Crédito</span>
                                            </div>
                                            <div className="billing_box_payment_item_image"><img className="billing_image_payment" src={image_cartao}></img></div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <span className="space_form"></span>
                            <span ref={refError} className="error_form"></span>
                            <span className="space_form"></span>

                            <button type="button" name="bt1" ref={refButton} className={isPaying ? "button_disabled_form" : "button_form"} onClick={create_payment} disabled={isPaying}>FAZER ASSINATURA</button>
                            </>
                            )}
                        </form>
                    </div>

                    </>
                    ) : (
                    <>
                    <span className="ft_topico">Gerencie seus pagamentos</span>
                    <span className="ft_descricao">Você é nosso assinante e aqui você poderá ver seu histórico de pagamentos e gerenciar sua conta.</span>
                    <div className="space"></div>

                    { isPending ? (
                    <>
                    <span>aguarde carregando ...</span>
                    </>
                    ) : (
                    <>
                    <div className="billing_subscriber_box">
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Histórico de lançamentos</span>
                            <span className="space_form"></span>
                            <div className="billing_subscriber_history_box">
                                <div class="billing_subscriber_history_scroll">

                                { historyPayment.parcelas?.map((item, index) => (
                                <>
                                    <div className="billing_subscriber_history_item">
                                        <span>Mensalidade:&nbsp;{item.mensalidade === 1 ? "assinatura" : item.mensalidade}</span>
                                        <span>Data de Vencimento:</span>
                                        <span>Data de Pagamento:</span>
                                        <span>Valor Pago:&nbsp;R$ {item.valor ? item.valor.toFixed(2): ""}</span>
                                        <span>Status:</span>
                                    </div>
                                    { index < historyPayment.parcelas?.length - 1 && (<><div className="billing_subscriber_history_space"></div></>)}
                                </>
                                ))}

                                </div>
                            </div>
                        </div>
                        <div className="billing_subscriber_boxB">
                            <div className="billing_subscriber_line"></div>
                        </div>
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Informações da assinatura</span>
                            <span className="space_form"></span>
                                <span>Data da Assinatura:&nbsp;{historyPayment.data_criacao ? formatTimestamp(historyPayment.data_criacao) : ""}</span>
                                <span>Dia de Vencimento:&nbsp;{historyPayment.dia_vencimento}</span>
                                <span>Próximo Vencimento:&nbsp;</span>
                                <span>Forma de Cobrança:&nbsp;{historyPayment.tipo}</span>
                                <span>----------------</span>
                                <span>Plano:&nbsp;{infoPlan.ramo}</span>
                                <span>Valor Atual:&nbsp;R$ {infoPlan.valor ? infoPlan.valor.toFixed(2) : ""}</span>
                                <span>Canais de Atendimento:</span>
                                <span>{infoPlan.atendimento}</span>
                        </div>
                        <div className="billing_subscriber_boxB">
                            <div className="billing_subscriber_line"></div>
                        </div>
                        <div className="billing_subscriber_boxA">
                            <span className="title_form">Forma de pagamento</span>
                            <span className="space_form"></span>
                            <span className="billing_subscriber_change">-- alterar a forma de pagamento --</span>
                            <span className="title_form">Cancelamento de assinatura</span>
                            <span className="subtitle_form" style={{textAlign: "center"}}>Quero cancelar minha assinatura e desativar o meu agente.</span>
                            <span className="space_form"></span>
                            <div className="billing_subscriber_cancel">
                                <button type="button" name="bt2" className="button_form" onClick={(e) => {setStep(6); window.scrollTo(0, 0);}}>CANCELAR ASSINATURA</button>
                            </div>
                        </div>
                    </div>
                    </>
                    )}
                    </>
                    )
                )}


                {/* tela de pagamento por pix ou boleto (dependendo da escola) - somente agentes status 3 (testes) */}
                { step === 1 && (
                <>
                <span className="ft_topico">Faça a sua assinatura</span>
                <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                <div className="space"></div>

                <div className="border_form billing_border_form">
                    <form className="form">

                        <span className="title_form">Pagamento {payment.charAt(0).toUpperCase() + payment.slice(1)}</span>
                        { payment === "pix" ? (
                        <>
                        <span className="subtitle_form">Você pode fazer seu pagamento Pix através do QR Code ou copiar o código através do botão abaixo.</span>
                        <span className="billing_payment_aviso">Após pagar, aguarde alguns instantes que iremos detectar seu pagamento.</span>
                        </>) : (
                        <>
                        <span className="subtitle_form">Você pode fazer seu pagamento do Boleto através do código de barras ou copiar os números da linha digitável, ou ainda, abrir o PDF se preferir.</span>
                        <span className="billing_payment_aviso">No pagamento por Boleto, o reconhecimento das transações demoram entre 1-2 dias úteis, você pode pagar e assim que detectarmos o pagamento, já alteraremos o status da sua assinatura.</span>
                        </>
                        )}
                        <span className="space_form"></span>

                        <TelaPagamento data={billingData} />
                    
                    </form>
                </div>
                </>
                )}


                {/* tela de conclusão: recebimento de pagamentos, alteração de pagamentos e encerramento da conta - somente agentes status 4 (assinantes) */}
                { step === 2 && (
                <>
                    { prevStep === 0 && (
                    <>
                    <span className="ft_topico">Pagamento efetuado</span>
                    <span className="main_space"></span>
                    <span className="ft_descricao">Como assinante, você tem acesso total a plataforma e seus respecitvos recursos.</span>
                    <div className="space"></div>
                    <img className="billing_success_image" src={icon_success}></img>
                    <div className="space"></div>
                    <span className="billing_success_01">{firstName(user.nome)}, seja bem vindo a winners-ai.com</span>
                    <span className="space"></span>
                    <span className="billing_success_02">{ payment === "credito" ? "Para sua comodidade, suas próximas mensalidades serão lançadas diretamente no seu cartão de crédito" : "Para sua comodidade, enviaremos para seu email o boleto/pix para que você possa pagar a mensalidade" }</span>
                    <span className="space"></span>
                    <span className="billing_success_03">1. Para mais detalhes sobre mensalidades, acesse: Painel do Cliente -&gt; Planos e pagamentos</span>
                    <span className="billing_success_03">2. Você poderá cancelar sua assinatura a qualquer momento (consulte nossos termos de uso)</span>                    
                    </>
                    )}

                    { prevStep === 6 && (
                    <>
                    <span className="ft_topico">Assinatura cancelada</span>
                    <span className="main_space"></span>
                    <span className="ft_descricao">{firstName(user.nome)}, sua conta com a winners-ai.com foi encerrada</span>
                    <div className="space"></div>
                    <img className="billing_success_image" src={icon_success}></img>
                    <div className="space"></div>
                    <span className="billing_success_02">Foi um prazer tê-lo como assinante, espero que tenha gostado da sua jornada conosco.</span>
                    <span className="space"></span>
                    <span className="billing_success_03">Caso tenha tido algum problema ou insatisfação, por favor, não deixe de dar seu feedback em nossos canais</span>
                    <span className="billing_success_03">Sua opinião é muito importante para a constante melhoria dos nossos serviços.</span>
                    </>
                    )}
                </>
                )}


                {/* tela para a alteração do cartão de crédito - somente agentes status 4 (assinantes) */}
                { step === 3 && (
                <>
                <span className="ft_topico">Altere seu cartão</span>
                <span className="ft_descricao">Alteração do cartão de crédito.</span>
                <div className="space"></div>

                
                </>
                )}


                {/* tela de pagamento por cartão de crédito - somente agentes status 3 (testes) */}
                { step === 4 && (
                <>
                <span className="ft_topico">Faça a sua assinatura</span>
                <span className="ft_descricao">Fazendo a sua assinatura, você garante o número de linha que você já testou, pode alterar seu agente e as respectivas configurações quando desejar e acompanhar a performance do agente mais detalhadamente.</span>
                <div className="space"></div>

                <div className="border_form billing_border_form">
                    <form className="form">
                        <span className="title_form">Cartão de Crédito</span>
                        <span className="subtitle_form">Como você optou por fazer a sua assinatura por cartão de crédito, precisamos que você preencha as informações abaixo.</span>
                        <span className="space_form"></span>

                        <span ref={refErrorNumeroCartao} className="error_form"></span>
                        <div className="billing_box_card">
                            <div className="billing_box_card1a">
                                <label for="inp" className="inp" ref={refLabelNumeroCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={19} {...register("card_number")} ref={(el) => {refNumeroCartao.current = el; register("card_number").ref(el);}} onClick={() => clearError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, error, setError)} onChange={(e) => {if (error === "0") {setValue("card_number", maskcartao(e.target.value));} else {clearError(refNumeroCartao, refLabelNumeroCartao, refErrorNumeroCartao, error, setError);}}}></input>
                                <span className="label">Número do Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1c">
                                <label for="inp" className="inp" ref={refLabelVencimentoCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={5} {...register("card_expiry")} ref={(el) => {refVencimentoCartao.current = el; register("card_expiry").ref(el);}} onClick={() => clearError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, error, setError)} onChange={(e) => {if (error === "0") {setValue("card_expiry", maskvencimento(e.target.value));} else {clearError(refVencimentoCartao, refLabelVencimentoCartao, refErrorNumeroCartao, error, setError);}}}></input>
                                <span className="label">Validade do Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>                            
                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorNomeCartao} className="error_form"></span>
                        <div className="billing_box_card">
                            <div className="billing_box_card1a">
                                <label for="inp" className="inp" ref={refLabelNomeCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={60} {...register("card_name")} ref={(el) => {refNomeCartao.current = el; register("card_name").ref(el);}} onClick={() => clearError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, error, setError)} onChange={() => clearError(refNomeCartao, refLabelNomeCartao, refErrorNomeCartao, error, setError)}></input>
                                <span className="label">Nome Impresso no Cartão</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1c">
                                <label for="inp" className="inp" ref={refLabelCodigoCartao}>
                                <input type="text" placeholder="&nbsp;" maxLength={3} {...register("card_code")} ref={(el) => {refCodigoCartao.current = el; register("card_code").ref(el);}} onClick={() => clearError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, error, setError)} onChange={() => clearError(refCodigoCartao, refLabelCodigoCartao, refErrorNomeCartao, error, setError)}></input>
                                <span className="label">Cód de Segurança</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>                            
                        </div>
                        <span className="space_form"></span>
                        <span className="billing_alert_card">A assinatura é mensal, a cada mês será lançado automaticamente o valor do plano que você escolheu na fatura do seu cartão de crédito. Você poderá cancelar a assinatura a qualquer momento.</span>

                        <span className="space_form"></span>
                        <span ref={refErrorCartao} className="error_form"></span>
                        <span className="space_form"></span>
                        
                        <div className="billing_box_card">
                            <div className="billing_box_card1c"><button type="button" name="bt4a" className={isPaying ? "button_disabled_form" : "button2_form"} onClick={() => setStep(0)} disabled={isPaying}>VOLTAR</button></div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1a"><button type="button" name="bt4b" ref={refButtonCartao} className={isPaying ? "button_disabled_form" : "button_form"} onClick={create_payment_card} disabled={isPaying}>FAZER PAGAMENTO</button></div>
                        </div>

                    </form>
                </div>
                </>
                )}


                {/* tela para a alteração da forma de pagamento: cartão -> pix/boleto ou pix/boleto -> cartão - somente agentes status 4 (assinantes) */}
                { step === 5 && (
                <>

                
                </>
                )}


                {/* cancelamento da assinatura e encerramento de conta - somente agentes status 4 (assinantes) */}
                { step === 6 && (
                <>
                <span className="ft_topico">Cancelar assinatura</span>
                <span className="ft_descricao">Cancelamento de assinatura e encerramento de conta, você pode encerrar a qualquer momento.</span>
                <div className="space"></div>

                <div className="border_form billing_border_form">
                    <form className="form">

                        <span className="title_form">Importante:</span>

                        <span className="subtitle_form">Ao cancelar sua assinatura, automaticamente sua conta e seu respectivo agente também serão encerrados.</span>
                        <span className="subtitle_form">Com o encerramento de seu agente, toda a configuração, histórico, atendimento e informações dele também serão desabilitadas.</span>
                        <span className="subtitle_form">O número da linha telefonica será disponibilizado a outro agente para outro cliente, não sendo possível futuramente, o vínculo a esse mesmo número.</span>
                        <span className="subtitle_form">Todas as suas mensalidades futuras serão canceladas a partir de hoje e você não precisará pagar mais nada.</span>

                        <span className="space_form"></span>
                        <span ref={refErrorTerms} className="error_form"></span>
                        <div className="billing_terms">
                            <input type="checkbox" className="checkbox_default" ref={refCheckBox}></input>
                            <span className="billing_terms_text">Estou ciente conforme os termos de uso.</span>
                        </div>
                        <span className="space_form"></span>
                        <span ref={refErrorCancelar} className="error_form"></span>
                        <span className="space_form"></span>

                        <div className="billing_box_card">
                            <div className="billing_box_card1c"><button type="button" name="bt6a" className="button2_form" onClick={(e) => {setStep(0); window.scrollTo(0, 0);}}>VOLTAR</button></div>
                            <div className="billing_box_card1b"></div>
                            <div className="billing_box_card1a"><button type="button" name="bt6b" className="button_form" onClick={cancell_subscription} disabled={isCancelling}>{isCancelling ? "AGUARDE ..." : "ENCERRAR CONTA"}</button></div>
                        </div>

                    </form>
                </div>
                </>
                )}

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>
        
        </div>

    )
}
